import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { ReplaySubject, BehaviorSubject, Observable } from 'rxjs';
import { PageParams } from '@app/constants';
import { FacetsService } from '@app/data';

@Component({
  selector: 'app-facets',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './facets.component.html',
  styleUrls: ['./facets.component.less']
})
export class FacetsComponent {

  @Input() pageParams$!: Observable<PageParams>;
  @Input() pageName!: string;

  public allFacets$ = this.facets.facets$;

  constructor(    
    private facets: FacetsService,
  ) { 
    //this.allFacets$.subscribe((data:any) => console.log('FacetsComponent allFacets$ data ', data));
  }

  public getEntries = (map: Map<string, any>): [string, any][] => {
      return Array.from(map.entries());
  }

  public getGroupName = (name: string): string => {
    let label = '';

    switch(name) {
      case 'stitky':
        label = 'Štítky';
        break;

      case 'sekce':
        label = 'Sekce';
        break; 

      case 'partneri':
        label = 'Organizace';
        break;
      
      case 'skoly':
        label = 'Školy';
        break;    

    }
    return label;
  }

  public showSection = (section: string): boolean => (section !== 'stitky' && this.pageName !== '/hledat') ? false : true;
  public hasFacets = (collection: any): boolean => (collection && collection.length > 0) ? true : false;
  public trackByMethod = (index:number, el:any): number => el.entityLabel;
  public showItem = (collection: any[] | null): boolean => /*collection!.length > 0*/ true;
}
